<template>
  <PageContainer v-if="isChina">
    <a-tabs
      v-if="
        hasActionPermission('center_order_order') ||
        hasActionPermission('center_order_invoice')
      "
      v-model:activeKey="activeKey"
      class="tab-wrapper -mt-[10px]"
    >
      <a-tab-pane
        v-if="hasActionPermission('center_order_order')"
        key="order"
        :tab="$t('ding-dan')"
      >
        <Order
          v-if="activeKey === 'order'"
          :isVerify="isVerify"
          :show="isChina"
          @check="checkApply"
        />
      </a-tab-pane>
      <a-tab-pane
        v-if="hasActionPermission('center_order_invoice')"
        key="invoice"
        :tab="$t('fa-piao')"
        force-render
      >
        <Invoice v-if="activeKey === 'invoice'" />
      </a-tab-pane>
      <template v-if="activeKey === 'order' && canApply" #rightExtra>
        <a-button
          type="primary"
          class="mt-[5px]"
          :disabled="!canApply"
          @click="goInvoice"
        >
          {{ $t('pi-liang-kai-piao') }}
        </a-button>
      </template>
    </a-tabs>
  </PageContainer>
  <PageContainer v-else :title="$t('ding-dan')">
    <Order :show="isChina" />
  </PageContainer>
</template>
<script lang="ts" setup>
import Order from './components/order.vue'
import Invoice from './components/invoice.vue'
import { USER_LEVEL_KEY } from '~/api/interface'
import { PageKey } from '~/constants/page'

const userInfo = useUserInfo()
const router = useRouter()
const { $t } = useNuxtApp()
const runtimeConfig = useRuntimeConfig()
const area = runtimeConfig.public.area

const { hasActionPermission } = usePageAndActionPermissionData()

const canApply = ref(false)

const isVerify = computed(() =>
  [
    USER_LEVEL_KEY.TASTE,
    USER_LEVEL_KEY.PERSONAL,
    USER_LEVEL_KEY.PERSONAL_LITE,
  ].includes(userInfo.value!.rights_type)
    ? true
    : userInfo.value?.is_identify
)

// 是否是国内
const isChina = area === 'CN'

const activeKey = ref(
  hasActionPermission('center_order_order') ? 'order' : 'invoice'
)

// watch(
//   () => activeKey.value,
//   () => {
//     if (activeKey.value === 'order') {
//       router.push({
//         name: PageKey.CENTER_ORDER,
//       })
//     }
//   }
// )

const goInvoice = () => {
  router.push({
    name: PageKey.CENTER_ORDER_INVOICE,
  })
}

const checkApply = (count: number) => {
  canApply.value = Boolean(count)
}

useUpdateUser()
</script>
<style lang="scss">
.tab-wrapper {
  .ant-tabs-nav {
    &::before {
      border-bottom: none !important;
    }
  }
  .ant-tabs-tab-btn {
    @apply text-font-50;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #121926 !important;
    font-weight: 500;
  }
}
</style>
